export enum TypeRepartitionEnum {
  TANTIEME = 'TANTIEME',
  SURFACE = 'SURFACE'
}
